import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty, isNil } from 'ramda'

import {
  setIsLaunch,
  setShouldScrollToProjects,
} from '../../../modules/miscUi/actions'
import {
  ThemedButton,
  ThemedAnchor,
  ThemedLink,
} from '../../../shared_components/ThemedButton'
import { selectShouldScrollToProjects } from '../../../modules/miscUi/selectors'
import { Box } from '../../../shared_components/UI/Box'
import Hero from '../../../shared_components/Hero'
import FeaturedProject from '../../../shared_components/FeaturedProject'
import HowItWorks, { Card } from '../../../shared_components/HowItWorks'
import { Container, HomePageSection } from '../styled'
import useFeaturedProject from '../useFeaturedProject'
import { b2bUrl } from '../../../shared_components/Header'
import useScrollToRef from '../../../hooks/useScrollToRef'
import LaunchLiveProjects from '../../../shared_components/LaunchLiveProjects'
import useFetchAndStoreLivePoolsData from '../../../hooks/pools/useFetchAndStoreLivePoolsData'
import useLiveProjects from '../useLiveProjects'
import UpcomingProjects from '../../../shared_components/UpcomingProjects'
import useUpcomingProjects, { formatPool } from '../useUpcomingProjects'
import useWeb3 from '../../../hooks/useWeb3'
import useFetchAndStoreAllPoolsData from '../../../hooks/pools/useFetchAndStoreAllPoolsData'
import { selectAllListPools } from '../../../modules/listPools/selectors'
import routes from '../../../router/routes'

export function LaunchLogo() {
  return (
    <img
      src="/logo-launch.svg"
      alt="zap launch logo"
      width="161px"
      height="28.319px"
    />
  )
}

export default function Launch() {
  const featuredProject = useFeaturedProject('launch')

  const { scrollRef: projectsRef, scrollToRef } = useScrollToRef()
  const scrollToProjects = useCallback(() => {
    scrollToRef()
  }, [scrollToRef])
  const shouldScrollToProjects = useSelector(selectShouldScrollToProjects)
  const dispatch = useDispatch()
  useEffect(() => {
    if (!shouldScrollToProjects) return
    scrollToProjects()
    dispatch(setShouldScrollToProjects(false))
  }, [shouldScrollToProjects, dispatch, scrollToProjects])

  useEffect(() => {
    dispatch(setIsLaunch(true))
  }, [dispatch])

  return (
    <Container>
      <Hero
        position="static"
        backgroundUrl="/hero-cover-launch.jpeg"
        logo={<LaunchLogo />}
        title="Fair launches, by the community for the community"
        subHeader="ZAP Launch rewards community members for their impact, while giving projects access to both capital and hype."
        buttons={
          <Box g={25} columnMobile>
            <ThemedAnchor href={b2bUrl}>Launch a token</ThemedAnchor>
            <ThemedButton $styleType="primary" onClick={scrollToProjects}>
              View projects
            </ThemedButton>
          </Box>
        }
      />
      {!isNil(featuredProject) && (
        <HomePageSection ref={projectsRef}>
          <FeaturedProject title="Hot Launch" project={featuredProject} />
        </HomePageSection>
      )}
      <div ref={projectsRef}>
        <LaunchProjects />
      </div>
      <HowItWorksLaunch />
      {/* <HomePageSection zIndex={'1'}>
        <SectionHeader>funded projects</SectionHeader>
        <SectionContentWrapper>
          <PadWrapper>
            <FundedProjects projects={fundedProjects} />
            <ViewAllButtonWrapper>
              <ThemedAnchor href="/pools/all">View all projects</ThemedAnchor>
            </ViewAllButtonWrapper>
          </PadWrapper>
        </SectionContentWrapper>
      </HomePageSection> */}
    </Container>
  )
}

export function LaunchProjects() {
  // const { dispatchLivePoolsToStore } = useFetchAndStoreLivePoolsData()
  // useEffect(() => {
  //   ;(async () => {
  //     await dispatchLivePoolsToStore('launch')
  //   })()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  // const liveProjects = useLiveProjects('launch')

  // temporary while we have low volume of pools
  const dispatchAllPoolsToStore = useFetchAndStoreAllPoolsData()
  useEffect(() => {
    dispatchAllPoolsToStore('', 8, 0, '', '')
  }, [dispatchAllPoolsToStore])
  const { pools, loading } = useSelector(selectAllListPools)
  // temporary while we have low volume of pools

  return (
    <>
      {/* <LaunchLiveProjects
          title="Launch Projects"
          backgroundUrl="/upcoming-cover-launch.png"
          projects={liveProjects}
          loading={liveProjects.loading}
        /> */}
      {/* temporary while we have low volume of pools */}
      <UpcomingProjects
        title="Launch Projects"
        backgroundUrl="/upcoming-cover-launch.png"
        projects={formatPool(pools)}
        loading={loading}
        viewAllButton={
          <Box ac jc>
            <ThemedLink to={routes.launch.pools}>View all projects</ThemedLink>
          </Box>
        }
      />
      {/* temporary while we have low volume of pools */}
    </>
  )
}

export function HowItWorksLaunch() {
  return (
    <HowItWorks backgroundUrl="/howitworks-cover-launch.png">
      <Card
        imageUrl="/howitworks-card-1-launch.jpeg"
        title="Step 1"
        subTitle="Discover"
        text="From the weird to the wonderful, memecoins to real utility, find your next gem on ZAP Launch"
      />
      <Card
        imageUrl="/howitworks-card-2-launch.jpeg"
        title="Step 2"
        subTitle="Participate"
        text="Complete missions to earn extra allocation in each raise. From social amplification to on-chain activities - there's something for everyone"
      />
      <Card
        imageUrl="/howitworks-card-3-launch.jpeg"
        title="Step 3"
        subTitle="Invest"
        text="Invest in one-click with the seamless launchpad experience"
      />
    </HowItWorks>
  )
}
